import cancellationPortal from '@cancellation-portal/internationalization/localization-messages/CancellationPortal/sv-SE.json';
import cancellationPortalAgencyAgreement from '@cancellation-portal/internationalization/localization-messages/cancellations/cancellation-portal/cancellation-portal-agency-agreement/sv-SE.json';

export const svSETranslations = {
  CancellationPortal: cancellationPortal,
  'cancellations/cancellation-portal/cancellation-portal-agency-agreement': cancellationPortalAgencyAgreement,
};
